import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import Section from "@/components/Section";

const Contact = () => {
  return (
    <>
      <SeoHead
        title="Contact Us | AI-labbet"
        description="Get in touch with AI-labbet. Contact us to discuss your AI strategy, governance needs, or training programs."
        path="/contact"
      />
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <PageBreadcrumb currentPage="Contact" />
        <main className="flex-grow">
          <Section
            eyebrow="Contact"
            title={<>Get in <span className="text-gradient-brand">Touch</span></>}
            titleAs="h1"
            description="Tell us about your AI ambitions — we'll get back within one business day."
            containerSize="narrow"
          >
            <div className="max-w-2xl mx-auto">
              <ContactForm />
            </div>
          </Section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
